class ExtendSectionHomeV3 extends ExtendSectionBase {
  constructor() {
    super();
    this._scrollEffects = [];
    this._resizeEffects = [];
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };

    // 初始化执行一次
    _safeInit(() => this._initVideoCards());
    _safeInit(() => this._initTestimonials());

    // 滚动驱动
    this._scrollEffects = [
      _safeInit(() => this._initPainPoint()),
      _safeInit(() => this._initSetupComparison()),
      _safeInit(() => this._initContentGrid()),
      _safeInit(() => this._initStoryReveal()),
      _safeInit(() => this._initCTABanner()),
    ].filter(Boolean);

    // 尺寸变化驱动
    this._resizeEffects = [
      _safeInit(() => this._initUseCases()),
      _safeInit(() => this._initWorkflowFeatures()),
      _safeInit(() => this._initCTABanner()),
    ].filter(Boolean);

    // 初始执行一次
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
    if (!!this._resizeEffects) {
      this._resizeEffects.forEach((fn) => fn());
    }
  }

  productInit() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this._initVideoCards());
    // 滚动驱动
    this._scrollEffects = [_safeInit(() => this._initContentGrid())].filter(
      Boolean
    );

    // 初始执行一次
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  onScroll() {
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  onResize() {
    super.onResize(); // 执行基类 _resizeFlktyListAll()
    if (!!this._resizeEffects) {
      this._resizeEffects.forEach((fn) => fn());
    }
  }

  // 【痛点】的特效
  _initPainPoint() {
    const painPointEl = document.querySelector(".extend-hv3-pain-point");
    if (!painPointEl) return null;
    const words = painPointEl.querySelectorAll(".ehv3pp__word");
    const START_THRESHOLD = 0.5;
    let isAnimating = false; // 状态缓存
    // 初始化：给每个 word 设置递增 delay，实现闪烁效果
    words.forEach((word, i) => {
      word.style.transitionDelay = `${i * 0.2}s`;
    });
    return () => {
      const rect = painPointEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.bottom < 0 || rect.top > viewportHeight) return;
      const progress = Math.max(0, Math.min(1, 1 - rect.top / viewportHeight));
      const shouldAnimate = progress >= START_THRESHOLD;
      if (shouldAnimate === isAnimating) return; // 状态未变跳过
      isAnimating = shouldAnimate;
      painPointEl.classList.toggle("animate", shouldAnimate);
    };
  }

  // 【设置对比】的特效
  _initSetupComparison() {
    const START_THRESHOLD = 0.55;
    let sectionStates = [];

    const _updateSection = (state) => {
      const sectionEl = state.sectionEl;
      if (!sectionEl.isConnected) return;

      const rect = sectionEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const progress = Math.max(0, Math.min(1, 1 - rect.top / viewportHeight));
      const shouldAnimate = progress >= START_THRESHOLD;

      if (shouldAnimate === state.isAnimating) return;

      state.isAnimating = shouldAnimate;
      sectionEl.classList.toggle("animate", shouldAnimate);
    };

    const _bindSection = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.ehv3scBound === "true") return;

      sectionEl.dataset.ehv3scBound = "true";

      // 移除已被编辑器替换的旧节点状态
      sectionStates = sectionStates.filter(
        (state) => state.sectionEl.isConnected
      );

      this._qa(".ehv3sc__setup", sectionEl).forEach((setupEl, i) => {
        setupEl.style.transitionDelay = `${i * 0.2}s`;
      });

      const state = {
        sectionEl,
        // 首次检查必须同步实际 DOM 状态
        isAnimating: null,
      };

      sectionStates.push(state);

      // 初始化及编辑器重载后立即检查，不等待滚动
      _updateSection(state);
    };

    this._registerSectionLoad({
      key: "hv3SetupComparison",
      className: "extend-hv3-setup-comparison",
      onLoad: (sectionEl) => {
        _bindSection(sectionEl);
      },
    });

    this._qa(".extend-hv3-setup-comparison").forEach((sectionEl) => {
      _bindSection(sectionEl);
    });

    return () => {
      sectionStates = sectionStates.filter(
        (state) => state.sectionEl.isConnected
      );

      sectionStates.forEach(_updateSection);
    };
  }

  // 【使用事例】的特效
  _initUseCases() {
    const useCasesEl = document.querySelector(".extend-hv3-use-cases");
    if (!useCasesEl) return null;
    const cases = useCasesEl.querySelectorAll(".ehv3uc__case");
    const images = useCasesEl.querySelectorAll(".ehv3uc__case-image");
    const imagesContainer = useCasesEl.querySelector(".ehv3uc__case-images");
    const imagesInner = useCasesEl.querySelector(".ehv3uc__case-images-inner");
    let activeIndex = 0;

    function goTo(index) {
      const imagesContainerHeight = imagesContainer.offsetHeight;
      cases.forEach((c) => c.classList.remove("is-active"));
      images.forEach((img) => img.classList.remove("is-active"));
      cases[index].classList.add("is-active");
      images[index].classList.add("is-active");
      const offset = (imagesContainerHeight + 10) * index;
      imagesInner.style.transform = `translateY(${-offset}px)`;
      activeIndex = index;
    }

    cases.forEach((item) => {
      item.addEventListener("click", () => {
        goTo(Number(item.dataset.index));
      });
    });

    return function onResize() {
      goTo(activeIndex);
    };
  }

  // 【内容网格】的特效
  _initContentGrid() {
    const contentGridEl = document.querySelector(".extend-hv3-content-grid");
    if (!contentGridEl) return null;

    const START_THRESHOLD = 0.5;
    const END_THRESHOLD = 0.95;

    const col02 = contentGridEl.querySelector(".ehv3cg__column02");
    const col03 = contentGridEl.querySelector(".ehv3cg__column03");
    const col04 = contentGridEl.querySelector(".ehv3cg__column04");

    // 缓动函数：慢→快→慢，比线性更自然
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 2);

    return function () {
      const gridEL = contentGridEl.querySelector(".ehv3cg__grid");
      const rect = gridEL.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const progress = Math.max(0, Math.min(1, 1 - rect.top / viewportHeight));

      const rawProgress = Math.max(
        0,
        Math.min(
          1,
          (progress - START_THRESHOLD) / (END_THRESHOLD - START_THRESHOLD)
        )
      );

      // 应用缓动
      const animProgress = easeOutCubic(rawProgress);
      const isNarrow = window.innerWidth < 1024;
      if (isNarrow) {
        // 小屏只移动 col03
        if (col03)
          col03.style.transform = `translateY(${120 * animProgress}px)`;
        if (col02) col02.style.transform = "";
        if (col04) col04.style.transform = "";
      } else {
        if (col02)
          col02.style.transform = `translateY(${120 * animProgress}px)`;
        if (col03)
          col03.style.transform = `translateY(${220 * animProgress}px)`;
        if (col04)
          col04.style.transform = `translateY(${120 * animProgress}px)`;
      }
    };
  }

  // 【工作流功能】的特效
  _initWorkflowFeatures() {
    const workflowFeaturesEl = document.querySelector(
      ".extend-hv3-workflow-features"
    );
    if (!workflowFeaturesEl) return null;
    const pcFeatureItemList = workflowFeaturesEl.querySelectorAll(
      ".ehv3wf__pc-feature-item"
    );
    const mobileNav = workflowFeaturesEl.querySelector(".ehv3wf__mobile-nav");
    const mobileTabList = workflowFeaturesEl.querySelectorAll(
      ".ehv3wf__mobile-tab"
    );
    const mobileContentWrapper = workflowFeaturesEl.querySelector(
      ".ehv3wf__mobile-content-list"
    );
    const mobileContentInner = workflowFeaturesEl.querySelector(
      ".ehv3wf__mobile-content-inner"
    );
    const mobileContentItemList = workflowFeaturesEl.querySelectorAll(
      ".ehv3wf__mobile-content-item"
    );
    const mediaWrapper = workflowFeaturesEl.querySelector(
      ".ehv3wf__media-wrapper"
    );
    const mediaInner = workflowFeaturesEl.querySelector(".ehv3wf__media-inner");
    const mediaItemList = workflowFeaturesEl.querySelectorAll(
      ".ehv3wf__media-item"
    );
    let activeIndex = 0;
    let activeType =
      window.getComputedStyle(mobileNav).display !== "none" ? "mobile" : "pc";

    function goTo(index, type) {
      if (type == "pc") {
        pcFeatureItemList.forEach((c) => c.classList.remove("is-active"));
        pcFeatureItemList[index].classList.add("is-active");
        // media
        const mediaWrapperHeight = mediaWrapper.offsetHeight;
        mediaItemList.forEach((img) => img.classList.remove("is-active"));
        mediaItemList[index].classList.add("is-active");
        const mediaInnerOffset = (mediaWrapperHeight + 10) * index;
        mediaInner.style.transform = `translateY(${-mediaInnerOffset}px)`;
      } else if (type == "mobile") {
        const mobileContentWidth = mobileContentWrapper.offsetWidth;
        mobileTabList.forEach((c) => c.classList.remove("is-active"));
        mobileTabList[index].classList.add("is-active");
        mobileContentItemList.forEach((c) => c.classList.remove("is-active"));
        mobileContentItemList[index].classList.add("is-active");
        // contentItem animate
        const contentInnerOffset = (mobileContentWidth + 10) * index;
        mobileContentInner.style.transform = `translateX(${-contentInnerOffset}px)`;
        // media
        const mediaWrapperWidth = mediaWrapper.offsetWidth;
        mediaItemList.forEach((img) => img.classList.remove("is-active"));
        mediaItemList[index].classList.add("is-active");
        const mediaInnerOffset = (mediaWrapperWidth + 10) * index;
        mediaInner.style.transform = `translateX(${-mediaInnerOffset}px)`;
      }
      activeIndex = index;
      activeType = type;

      // 控制视频播放/暂停
      mediaItemList.forEach((el, i) => {
        if (el.dataset.showVideo === "false") {
          return;
        }
        const videoContainer = Array.from(
          el.querySelectorAll(".ehv3wf__media-video")
        ).find((item) => getComputedStyle(item).display !== "none");
        const videoMedia = videoContainer.querySelector("video-media");
        if (!videoMedia) return;

        if (i === index) {
          // 激活：先初始化（挂载 template），再播放
          const player = videoMedia.playerTarget();
          videoMedia.playerHandler(player, "play");
        } else {
          // 非激活：只有已加载才暂停
          if (videoMedia.hasAttribute("loaded")) {
            const video = videoMedia.querySelector("video");
            if (video) videoMedia.playerHandler(video, "pause");
          }
        }
      });
    }

    pcFeatureItemList.forEach((item) => {
      item.addEventListener("click", () => {
        goTo(Number(item.dataset.index), "pc");
      });
    });
    mobileTabList.forEach((item) => {
      item.addEventListener("click", () => {
        goTo(Number(item.dataset.index), "mobile");
      });
    });

    return function onResize() {
      goTo(activeIndex, activeType);
    };
  }

  // 【视频卡片】的特效
  _initVideoCards() {
    const videoCardsEl = document.querySelector(".extend-hv3-video-cards");
    if (!videoCardsEl) return;
    const sliderEl = videoCardsEl.querySelector(".ehv3vc__slider");
    const showSliderArrows = sliderEl.dataset.showSliderArrows === "true";
    let flkty = new Flickity(sliderEl, {
      cellAlign: "left", // 左对齐
      contain: true, // 防止滑动元素溢出，为false时最后一个后面会有大量空白
      autoPlay: false, // 自动播放
      pauseAutoPlayOnHover: false, // 用户点击或悬停时不暂停自动播放
      wrapAround: false, // 循环播放
      prevNextButtons: showSliderArrows, // 显示前后按钮
      pageDots: false, // 显示分页指示器
    });
    this._bindFlktyResizeDebounce(flkty, "homeV3VideoCards", () =>
      this._setFlktyCellsEqualHeight(sliderEl, flkty)
    );
    this._waitAndSetEqualHeight(sliderEl, flkty);
    this._flktyListObj.homeV3VideoCardsFlktyList = [flkty];
  }

  // 【用户证言】特效
  _initTestimonials() {
    const testimonialsEl = document.querySelector(".extend-hv3-testimonials");
    if (!testimonialsEl) return;
    if (testimonialsEl.dataset.ehv3tInitialized === "true") {
      return;
    }
    const wrapperEl = testimonialsEl.querySelector(".ehv3t__wrapper");
    const innerEl = wrapperEl.querySelector(".ehv3t__inner");
    if (!wrapperEl || !innerEl) return;
    testimonialsEl.dataset.ehv3tInitialized = "true";
    const cloneEl = innerEl.cloneNode(true);
    cloneEl.classList.add("ehv3t__inner--clone");
    wrapperEl.appendChild(cloneEl);
    let resizeTimer = null;
    let animationFrame = null;
    function startMarquee() {
      const innerWidth = innerEl.offsetWidth;
      const cloneStyle = window.getComputedStyle(cloneEl);
      const marginLeft = parseFloat(cloneStyle.marginLeft) || 0;
      const wrapperStyle = window.getComputedStyle(wrapperEl);
      const columnGap = parseFloat(wrapperStyle.columnGap) || 0;
      const distance = innerWidth + marginLeft + columnGap;
      const speed = window.innerWidth <= 768 ? 45 : 50;
      const duration = distance / speed;
      wrapperEl.style.setProperty("--ehv3t-distance", `-${distance}px`);
      wrapperEl.style.animationDuration = `${duration}s`;
    }
    function handleResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        startMarquee();
      }, 150);
    }
    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });
    resizeObserver.observe(testimonialsEl);
    resizeObserver.observe(innerEl);
    startMarquee();
  }

  // 【多阶段叙事】动效
  _initStoryReveal() {
    const storyRevealEl = document.querySelector(".extend-hv3-story-reveal");
    if (!storyRevealEl) return null;
    const storyBg = storyRevealEl.querySelector(".ehv3sr__bg");
    const revealStage = storyRevealEl.querySelector(".ehv3sr__reveal-stage");
    const revealInfo = storyRevealEl.querySelector(".ehv3sr__info");

    function clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    }
    // 缓入缓出（最自然）
    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    // 缓出（先快后慢，适合滑入停止）
    function easeOut(t) {
      return 1 - (1 - t) * (1 - t);
    }
    // 缓入（先慢后快，适合开始扩展）
    function easeIn(t) {
      return t * t;
    }

    return () => {
      const rect = storyRevealEl.getBoundingClientRect();
      const scrollable = rect.height - window.innerHeight;
      const progress = clamp(-rect.top / scrollable, 0, 1);

      // Phase A: bg 层淡入
      const storyBgRect = storyBg.getBoundingClientRect();
      const visibleTop = Math.max(storyBgRect.top, 0);
      const visibleBottom = Math.min(storyBgRect.bottom, window.innerHeight);
      const visibleHeight = Math.max(visibleBottom - visibleTop, 0);
      const bgRatio = visibleHeight / storyBg.offsetHeight;
      storyBg.style.opacity = bgRatio;

      // Phase B: 横向撕裂
      // Phase C: 纵向撕裂
      const CRACK_TOP = 46; // 上裁切 45%
      const CRACK_BOT = 46; // 下裁切 45%（缝高 = 10%）
      const tB = clamp((progress - 0) / 0.3, 0, 1);
      const tC = clamp((progress - 0.28) / 0.32, 0, 1);
      const tB_eased = easeInOut(tB);
      const tC_eased = easeIn(tC);

      if (progress <= 0.3) {
        // B 阶段：横向扩展，缝高固定
        const rightCut = (1 - tB_eased) * 100;
        revealStage.style.clipPath = `inset(${CRACK_TOP}% ${rightCut.toFixed(2)}% ${CRACK_BOT}% 0)`;
      } else {
        // C 阶段：从 B 结束的状态（45% 0% 45% 0）开始纵向扩展
        const vCut = CRACK_TOP * (1 - tC_eased); // 45% → 0%
        revealStage.style.clipPath = `inset(${vCut.toFixed(2)}% 0% ${vCut.toFixed(2)}% 0)`;
      }

      // Phase D: 文字渐隐
      const tD = clamp((progress - 0.58) / 0.2, 0, 1);
      const infoOpacity = 0.6 + tD * 0.4;
      revealInfo.style.opacity = progress >= 0.58 ? infoOpacity : 0.6;

      // Phase E: 显示文案
      if (progress >= 0.62) {
        storyRevealEl.classList.add("animation-info");
      } else {
        storyRevealEl.classList.remove("animation-info");
      }
    };
  }

  // 【CTA Banner】动效
  _initCTABanner() {
    const ctaBannerEl = document.querySelector(".extend-hv3-cta-banner");
    if (!ctaBannerEl) return null;
    const wrapper = ctaBannerEl.querySelector(".ehv3cb__wrapper");
    return () => {
      const rect = ctaBannerEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const len = viewportHeight > rect.height ? rect.height : viewportHeight;
      if (rect.top <= viewportHeight && rect.top >= 0) {
        const progress = parseFloat(((len - rect.top) / len).toFixed(2));
        const tA = Math.min(30, Math.max(0, 30 * (1 - progress)));
        wrapper.style.transform = `translateY(-${tA}%)`;
      }
    };
  }
}
